"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpErrorOut = void 0;
class HttpErrorOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return HttpErrorOut.attributeTypeMap;
    }
}
exports.HttpErrorOut = HttpErrorOut;
HttpErrorOut.discriminator = undefined;
HttpErrorOut.attributeTypeMap = [
    {
        "name": "code",
        "baseName": "code",
        "type": "string",
        "format": ""
    },
    {
        "name": "detail",
        "baseName": "detail",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=HttpErrorOut.js.map